import * as React from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Paper, { PaperProps } from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { OrderRow } from '../../../BookingsCalendarTypes';
import { ProductsToSplitOn, ProductsToSplitOnLabels } from './ProductsToSplitOn';
import { MainProducts } from './MainProducts';
import { separateMainProductsAndAdditionProducts } from "../state/splitProductUtils";

type SplitOrderModalLabels = {
    title: string;
    description: string;
    submitButton: string;
    mainProductTitle: string;
} & ProductsToSplitOnLabels;

type SplitOrderModalProps = {
    isOpen: boolean;
    onClose: () => void;
    labels: SplitOrderModalLabels;
    products: OrderRow[];
    orderId: number;
    onSubmit: (formData: FormData) => void;
};

function PaperComponent(props: PaperProps) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}

function CloseButton({ onClose }: { onClose: () => void }) {
    return (
        <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
                color: (theme: any) => theme.palette.grey[500]
            }}
        >
            <CloseIcon />
        </IconButton>
    );
}

const PRODUCT_FORM_ID = 'product-form';

export function SplitOrderModal({
    isOpen,
    onClose,
    labels,
    onSubmit,
    orderId,
    products
}: SplitOrderModalProps) {
    let { mainProducts, additionProducts } = separateMainProductsAndAdditionProducts(products);

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >
            <Box
                id="draggable-dialog-title"
                sx={{
                    display: 'flex'
                }}
            >
                <DialogTitle style={{ cursor: 'move' }}>{labels.title}</DialogTitle>
                <Box sx={{ flex: '1 auto' }} />
                <CloseButton onClose={onClose} />
            </Box>
            <DialogContentText sx={{ padding: '0 24px' }}>{labels.description}</DialogContentText>
            <DialogContent>
                <MainProducts labels={{ title: labels.mainProductTitle }} products={mainProducts} />
                <ProductsToSplitOn
                    formId={PRODUCT_FORM_ID}
                    products={additionProducts}
                    hasMainProduct={mainProducts.length > 0}
                    onSubmit={onSubmit}
                    orderId={orderId}
                    closeSplitOrderModal={onClose}
                    labels={{
                        canNotSplitOnNoProducts: labels.canNotSplitOnNoProducts,
                        canNotSplitAllProducts: labels.canNotSplitAllProducts
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    type="submit"
                    form={PRODUCT_FORM_ID}
                    variant="contained"
                    disabled={additionProducts.length < 1}
                >
                    {labels.submitButton}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
